import { gsap } from 'gsap';
import React, { useEffect, useRef } from 'react';
import mainSymbol from '../assets/img/main-symbol.png';

const Intro = () => {
  const mainSymbolRef = useRef(null);
  const mainLogoRef = useRef(null);
  const mainLocationRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    // 초기 상태 설정
    gsap.set(mainLogoRef.current, {
      letterSpacing: '-0.3em',
      opacity: 0,
      textIndent: '1px',
    });
    gsap.set(mainLocationRef.current, {
      letterSpacing: '-0.3em',
      opacity: 0,
      textIndent: '1px',
    });

    const playAnimation = () => {
      if (animationRef.current) {
        animationRef.current.kill();
      }

      // Symbol 회전은 CSS 애니메이션으로 처리 (클래스 추가)
      mainSymbolRef.current.classList.add('ani');

      // 자간 애니메이션은 GSAP로 처리
      const tl = gsap.timeline();

      // MOSU 텍스트 letter-spacing 애니메이션
      tl.fromTo(
        mainLogoRef.current,
        { letterSpacing: '-0.3em', opacity: 0, textIndent: '1px' },
        {
          letterSpacing: '1.04rem',
          opacity: 1,
          textIndent: '17px',
          duration: 2.5,
          ease: 'power2.out',
        },
        0
      );

      // SEOUL 텍스트 letter-spacing 애니메이션
      tl.fromTo(
        mainLocationRef.current,
        { letterSpacing: '-0.3em', opacity: 0, textIndent: '1px' },
        {
          letterSpacing: '0.22rem',
          opacity: 1,
          textIndent: '5px',
          duration: 2.1,
          ease: 'power2.out',
        },
        0.3
      );

      animationRef.current = tl;
    };

    const hideElements = () => {
      mainSymbolRef.current.classList.add('hide');
      gsap.to([mainLogoRef.current, mainLocationRef.current], {
        opacity: 0.3,
        duration: 0.3,
      });
    };

    const resetElements = () => {
      mainSymbolRef.current.classList.remove('hide');
      mainSymbolRef.current.classList.remove('ani');
      // 초기 상태로 리셋
      gsap.set(mainLogoRef.current, {
        letterSpacing: '-0.3em',
        opacity: 0,
        textIndent: '1px',
        clearProps: 'all',
      });
      gsap.set(mainLocationRef.current, {
        letterSpacing: '-0.3em',
        opacity: 0,
        textIndent: '1px',
        clearProps: 'all',
      });
    };

    const handleScroll = () => {
      const scrollPercent =
        (window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight)) *
        100;

      if (scrollPercent > 20) {
        hideElements();
      }
    };

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          playAnimation();
        } else {
          resetElements();
        }
      }
    });

    window.addEventListener('scroll', handleScroll);
    const introSection = document.querySelector('.intro__inner');
    if (introSection) observer.observe(introSection);

    window.scrollTo(0, 0);

    setTimeout(() => {
      playAnimation();
    }, 200);

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
      if (animationRef.current) {
        animationRef.current.kill();
      }
    };
  }, []);

  return (
    <section id="intro" data-section="intro">
      <div className="intro__inner">
        <img
          alt="MOSU Symbol"
          src={mainSymbol}
          className="main-intro-symbol"
          ref={mainSymbolRef}
        />
        <div className="txt-logo-mosu" ref={mainLogoRef}>
          MOSU
        </div>
        <div className="txt-logo-location" ref={mainLocationRef}>
          SEOUL
        </div>
      </div>
    </section>
  );
};

export default Intro;
